import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { API } from "./constants";

export function LoginForm({ onLogin }) {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { password });
      onLogin(password);
    } catch {
      toast.error("Неверный пароль");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-testid="admin-login">
      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-sm">
        <div className="flex justify-center mb-6">
          <Logo variant="dark" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 text-center mb-6">Админ-панель</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Пароль"
            className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-pink-400 focus:ring-2 focus:ring-pink-100 outline-none mb-4"
            data-testid="admin-password-input"
          />
          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full bg-gradient-to-r from-pink-500 to-rose-500 text-white h-12 rounded-xl font-bold"
            data-testid="admin-login-btn"
          >
            {loading ? "Проверка..." : "Войти"}
          </Button>
        </form>
      </div>
    </div>
  );
}
